import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  postDetails: null,
  isReady:false
};

export const ltiSlice = createSlice({
  name: 'ltiState',
  initialState,
  reducers: {
    setLti: (state, action) => ({
      ...state,
      postDetails: action.payload,
    }),
    setLTIReady: (state, action) => {
      state.isReady = action.payload;
    },
  },
});

export const { setLti, setLTIReady } = ltiSlice.actions;
export default ltiSlice.reducer;
